// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../imageSize.fragment.generated';
import { ContentComponentItemFragmentDoc } from '../ContentComponentItem.fragment.generated';
import { ComponentTitleFragmentDoc } from '../content/ContentTitle.fragment.generated';
import { ComponentTitleComponentFragmentDoc } from '../content/componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from '../content/componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from '../content/componentTitleText.fragment.generated';
import { ComponentTextFragmentDoc } from '../content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from '../content/ContentButton.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../index.generated';
import { ComponentSpacerFragmentDoc } from '../content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from '../content/ContentImage.fragment.generated';
import { ComponentOrderedListFragmentDoc } from '../content/ContentOrderedList.fragment.generated';
import { OrderedListItemFragmentDoc } from '../content/orderedListItem.generated';
export const ComponentSideBySideImageFragmentDoc = `
    fragment componentSideBySideImage on ComponentSideBySideImage {
  image {
    ...cmsImageSizes
  }
  caption
  content {
    ...contentComponentItem
  }
  link {
    ...link
  }
}
    `;